import React from 'react';
import { Pencil, Trash2, Eye, FileText, IndianRupee, User, Gavel, Shield, Star } from 'lucide-react';

const StepCard = ({ step, onEdit, onDelete, onToggle }) => {
    console.log('StepCard Rendered:', { id: step?.id, hasOnEdit: !!onEdit, hasOnDelete: !!onDelete, hasOnToggle: !!onToggle });
    // Icon Mapping
    const iconMap = {
        Eye,
        FileText,
        IndianRupee,
        User,
        Gavel,
        Shield
    };

    const IconComponent = iconMap[step.icon] || Star;

    // Gradient Colors Configuration
    const gradients = [
        { from: 'from-blue-500', to: 'to-cyan-400', bg: 'bg-blue-50', text: 'text-blue-600' },
        { from: 'from-emerald-500', to: 'to-lime-400', bg: 'bg-emerald-50', text: 'text-emerald-600' },
        { from: 'from-pink-500', to: 'to-rose-400', bg: 'bg-pink-50', text: 'text-pink-600' },
        { from: 'from-amber-500', to: 'to-orange-400', bg: 'bg-amber-50', text: 'text-amber-600' },
        { from: 'from-violet-500', to: 'to-purple-400', bg: 'bg-violet-50', text: 'text-violet-600' },
        { from: 'from-teal-500', to: 'to-cyan-400', bg: 'bg-teal-50', text: 'text-teal-600' },
    ];

    // Pick color based on display_order
    const colorIndex = (step.display_order - 1) % gradients.length;
    const colorTheme = gradients[colorIndex >= 0 ? colorIndex : 0]; // Fallback to 0 if negative or undefined



    return (
        <div className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden hover:shadow-md transition-all group h-full flex flex-col">
            {/* Top Color Bar */}
            <div className={`h-2 bg-gradient-to-r ${colorTheme.from} ${colorTheme.to}`}></div>

            <div className="p-6 flex flex-col flex-grow">
                <div className="flex items-start justify-between mb-4">
                    {/* Icon Box */}
                    <div className={`p-4 rounded-xl bg-gradient-to-br ${colorTheme.from} ${colorTheme.to} text-white shadow-sm`}>
                        <IconComponent size={24} />
                    </div>

                    {/* Action Buttons - Always visible for better UX and debugging */}
                    <div className="flex items-center gap-2 relative z-10">
                        <button
                            type="button"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                console.log('Edit button clicked for step:', step.id);
                                onEdit(step);
                            }}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-primary-600 transition-colors"
                            title="Edit"
                        >
                            <Pencil size={18} />
                        </button>
                        <button
                            type="button"
                            onClick={(e) => {
                                e.stopPropagation();
                                onDelete(step.id);
                            }}
                            className="p-2 hover:bg-slate-50 rounded-lg text-slate-400 hover:text-red-600 transition-colors"
                            title="Delete"
                        >
                            <Trash2 size={18} />
                        </button>
                    </div>
                </div>

                <div className="space-y-4 flex-grow">
                    <div className="flex items-center justify-between">
                        <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wider ${step.is_active ? 'bg-green-50 text-green-600' : 'bg-slate-100 text-slate-500'}`}>
                            {step.is_active ? 'Active' : 'Inactive'}
                        </span>
                        <span className="text-[10px] font-bold text-slate-400">ORDER #{step.display_order}</span>
                    </div>

                    <div>
                        <h3 className="font-bold text-slate-800 text-lg mb-2">{step.title}</h3>
                        <p className="text-slate-500 text-sm leading-relaxed">
                            {step.description}
                        </p>
                    </div>
                </div>

                {/* Step Number Badge */}
                <div className="pt-4 mt-auto border-t border-slate-50 flex justify-between items-center">
                    <span className="text-xs font-semibold text-slate-400">Step Number</span>
                    <span className={`text-sm font-bold ${colorTheme.text}`}>{step.step_number}</span>
                </div>
            </div>
        </div>
    );
};

export default StepCard;
